import { db } from '@/db/db';

/** Sync bookkeeping in Dexie meta: the server cursor, last sync time, and the learned clock offset. */
export const SYNC_META = { cursor: 'sync.cursor', lastAt: 'sync.lastAt', offset: 'sync.serverOffsetMs', error: 'sync.error' } as const;

export const getCursor = async () => ((await db.meta.get(SYNC_META.cursor))?.value as number | undefined) ?? 0;
export const setCursor = (cursor: number) => db.meta.put({ key: SYNC_META.cursor, value: cursor });
export const setLastSync = (at: string) => db.meta.put({ key: SYNC_META.lastAt, value: at });
export const setSyncError = (message: string | null) => (message ? db.meta.put({ key: SYNC_META.error, value: message }) : db.meta.delete(SYNC_META.error));

export async function resetSyncState() {
  await Promise.all([db.meta.delete(SYNC_META.cursor), db.meta.delete(SYNC_META.lastAt), db.meta.delete(SYNC_META.error)]);
}
